var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Thêm ca cho : " + _vm.teamName,
        visible: _vm.dialogVisible,
        width: "80%",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: {
            "highlight-current-row": "",
            "empty-text": _vm.textTable,
            data: _vm.responseList,
            "cell-style": _vm.tableRowStyle,
            "header-cell-style": _vm.tableHeaderColor,
            "max-height": _vm.$tableMaxHeight,
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              label: "STT",
              width: "50",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "name", label: "Tên ca", "min-width": "190" },
          }),
          _c("el-table-column", {
            attrs: { prop: "description", label: "Mô tả", "min-width": "180" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "startTime",
              align: "center",
              label: "Thời gian bắt đầu",
              "min-width": "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "endTime",
              align: "center",
              label: "Thời gian kết thúc",
              "min-width": "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "autoAttendanceEnable",
              align: "center",
              label: "Đối tượng áp dụng",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.targetType === "STUDENT"
                      ? _c("span", [_vm._v("Học sinh")])
                      : _vm._e(),
                    scope.row.targetType === "TEACHER"
                      ? _c("span", [_vm._v("Nhân viên")])
                      : _vm._e(),
                    scope.row.targetType === "GROUP"
                      ? _c("span", [_vm._v("Nhóm")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "autoAttendanceEnable",
              align: "center",
              label: "Điểm danh tự động AI",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.autoAttendanceEnable
                      ? _c("span", [_vm._v("Có")])
                      : _c("span", [_vm._v("Không")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { fixed: "right", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v("Áp dụng")]),
                    _c("el-checkbox", {
                      on: {
                        change: function ($event) {
                          return _vm.checkUseAllMethod(scope.$index)
                        },
                      },
                      model: {
                        value: _vm.checkAll,
                        callback: function ($$v) {
                          _vm.checkAll = $$v
                        },
                        expression: "checkAll",
                      },
                    }),
                  ]
                },
              },
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-checkbox", {
                      model: {
                        value: scope.row.assigned,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "assigned", $$v)
                        },
                        expression: "scope.row.assigned",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { type: "flex" } },
        [
          _c(
            "el-col",
            { staticStyle: { margin: "15px 0" }, attrs: { span: 22 } },
            [
              _c(
                "div",
                { staticClass: "container_nav_page" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "prev, pager, next, sizes",
                      "current-page": _vm.dataSearch.page,
                      "page-sizes": _vm.listSizePage,
                      total: _vm.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentPageChange,
                      "update:currentPage": function ($event) {
                        return _vm.$set(_vm.dataSearch, "page", $event)
                      },
                      "update:current-page": function ($event) {
                        return _vm.$set(_vm.dataSearch, "page", $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c("el-col", { attrs: { span: 4 } }, [
            _c("div", { staticStyle: { float: "right", margin: "15px 0" } }, [
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "medium" },
                      on: {
                        click: function ($event) {
                          return _vm.closeDialog()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-close" }),
                      _c("span", [_vm._v("Đóng")]),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "success",
                        size: "medium",
                        loading: _vm.loadingButton,
                        mini: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-check" }),
                      _c("span", [_vm._v("Lưu")]),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }